import { OfferStatus } from '../offer/offer.enums';
import { TOfferKind } from '../offer/offer.types';

export enum CvUploadStatus {
  PROCESSING,
  UPLOADED,
  ERROR,
}

export enum CsvImportStatus {
  UPLOADED = 'uploaded',
  MAPPED = 'mapped',
  ASSIGNED = 'assigned',
  PARSED = 'parsed',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  IN_PROGRESS = 'in_progress',
}

export type CsvOffer = {
  count: number;
  default: boolean;
  name: string;
  offerId: null | number;
  stageId: null | number | string;
};

export type CsvColumn = {
  value: string;
  name: string;
  match: null | string;
};

export type CsvMappedOffer = CsvOffer & {
  selectedOffer: CsvOfferModel;
  checked: boolean;
};

export type CsvFileModel = {
  fileName: string;
  status: CvUploadStatus;
  importCandidateId: number | null;
  errorMessage: string;
  deleting: boolean;
  id: number;
  fileUrl: string;
};

export type CsvOfferModel = {
  id?: number;
  title?: string;
  checked?: boolean;
  stages: {
    id: number | string;
    name: string;
    option: string;
    value: number | string;
  }[];
  status: OfferStatus | null;
  kind: TOfferKind | null;
  option: string | null;
  value: number | null;
};

export type CsvCandidate = {
  emails: string[];
  id: number;
  name: string;
};

export type CsvImport = {
  admin: {
    type: string;
    photoThumbUrl: string;
    lastName: string;
    id: number;
    firstName: string;
    email: string;
  };
  adminId: number;
  fileName: string;
  fileUrl: string;
  id: number;
  name: string;
  status: CsvImportStatus;
  offers?: CsvOffer[];
  columns?: CsvColumn[];
  delimiter?: string;
  merge?: boolean;
  sources?: string[];
  sourceId: number | null;
};

export type CsvImportCv = {
  fileName: string;
  fileUrl: string;
  id: number;
  importCandidateId: null | number;
};
